import { garageItem } from '@/services/AccountSettings/Garages/GarageModal/store'
import { hoaUtility } from '@/services/Hoa/store'

import $ from 'jquery'
import { notifyError } from '@/services/notify'
import _get from 'lodash/get'
import debounce from 'lodash/debounce'
import parseAddress from '@/utilities/address/parse'

export const methods = {
  async reload() {
    this.loading = true

    this.getAddressDropDown()

    console.log('test=' + JSON.stringify(this.garage))

    if (this.garage && this.garage != undefined) {
      if (
        this.addressDropDownList &&
        this.addressDropDownList != undefined &&
        this.garage.unit &&
        this.garage.unit != undefined
      ) {
        this.addressFilterQuery = parseAddress({
          address: _get(this.garage, 'unit.address', '')
        })

        const address1 = this.garage.unit.address.addressOne
        const address2 = this.garage.unit.address.addressTwo
        const addressCity = this.garage.unit.address.city
        const addressState = this.garage.unit.address.state
        const addressPostal = this.garage.unit.address.postalCode

        const fullAddress = `${address1 ? address1 + ', ' : ''}${address2 ? address2 : ''}${
          addressCity ? addressCity : ''
        } ${addressState ? addressState : ''}  ${addressPostal ? addressPostal : ''}`

        this.addressFilterQuery = fullAddress ? fullAddress : ''
      }

      //Update
      this.buttonText = 'Save'

      this.formData.garageID = this.garage.garageID
      this.formData.garageNumber = this.garage.garageNumber
      this.formData.vehicleCapacity = this.garage.vehicleCapacity
      this.formData.squareFeet = this.garage.areaSquareFeet
      this.formData.unitID = this.garage.unitID
      this.loading = false
    } else {
      this.buttonText = 'Add'
      this.loading = false
    }

    this.loading = false
  },

  async getAddressDropDown() {
    const hoaID = _get(this, ['$store', 'getters', 'user/hoaIDInteger'], null)
    await hoaUtility
      .dispatch('loadDropDownAddressList', {
        hoaID: hoaID
      })
      .then(({ list }) => {
        if (list) {
          if (this.isDebug == true) console.debug('addressDropDownList=' + JSON.stringify(list))

          this.addressData = list
          this.addressDropDownList = list
        }
      })
  },

  open() {
    this.formData = {
      garageNumber: '',
      vehicleCapacity: 0,
      areaSquareFeet: 0,
      unitID: 0
    }
    this.isOpen = true
    this.loading = false
  },

  async submitGarage() {
    if (this.formData && this.formData != undefined) {
      if (this.formData.garageID && this.formData.garageID > 0) {
        await this.updateGarage()
      } else {
        await this.addGarage()
      }
    }
  },

  async addGarage() {
    if (!this.formData || this.formData == undefined) {
      notifyError('There was a problem processing this garage.')
      return
    }

    this.loading = true
    const hoaID = _get(this, ['$store', 'getters', 'user/hoaIDInteger'], null)

    const address = this.addressDropDownList.filter(i => i.label.includes(this.addressFilterQuery))
    if (address && address != undefined) {
      this.formData.unitID = address && address[0] && address[0].unitID ? address[0].unitID : 0
    }

    await garageItem.dispatch('addGarage', {
      hoaID,
      garageNumber: this.formData.garageNumber ? this.formData.garageNumber : '',
      vehicleCapacity: this.formData.vehicleCapacity ? this.formData.vehicleCapacity : 0,
      areaSquareFeet: this.formData.squareFeet ? this.formData.squareFeet : 0,
      unitID: this.formData.unitID && this.formData.unitID > 0 ? this.formData.unitID : null,
      done: () => {
        // auto-close modal
        this.$emit('update:toggle', (this.toggle = false))
        $('#clickclose').click()
        this.loading = false
      }
    })
  },

  async updateGarage() {
    if (!this.formData || this.formData == undefined) {
      notifyError('There was a problem updating this garage.')
      return
    }

    this.loading = true
    const hoaID = _get(this, ['$store', 'getters', 'user/hoaIDInteger'], null)
    const filterQuery = this.addressFilterQuery
    const address = this.addressDropDownList.filter(i => i.label.includes(filterQuery))
    if (address && address != undefined) {
      this.formData.unitID = address && address[0] && address[0].unitID ? address[0].unitID : 0
    }

    const payload = {
      garageID: this.formData.garageID,
      hoaID: hoaID,
      garageNumber: this.formData.garageNumber ? this.formData.garageNumber : '',
      vehicleCapacity: this.formData.vehicleCapacity ? this.formData.vehicleCapacity : 0,
      areaSquareFeet: this.formData.squareFeet ? this.formData.squareFeet : 0,
      unitID: this.formData.unitID && this.formData.unitID > 0 ? this.formData.unitID : null
    }

    await garageItem.dispatch('updateGarage', {
      payload: payload,
      done: () => {
        // auto-close modal
        this.$emit('update:toggle', (this.toggle = false))
        $('#clickclose').click()
        this.loading = false
      }
    })
  },

  getAsyncData: debounce(function(name) {
    // String update
    if (this.name !== name) {
      this.name = name
      this.addressData = []
    }

    // String cleared
    if (!name.length) {
      this.addressData = []
      return
    }

    this.isFetching = true
    if (this.isDebug == true) console.debug('this.name=' + this.name)

    if (this.addressDropDownList && this.addressDropDownList) {
      this.addressData = this.addressDropDownList.filter(i =>
        i.label.toLowerCase().includes(this.name.toLowerCase())
      )
    }
    this.isFetching = false
  }, 500),
  getMoreAsyncData: debounce(function() {
    this.getAsyncData(this.name)
  }, 250)
}
